import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Mutations } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useUpdateTaxDocument = () => {
  const context = useAuthContext('tax_documents:edit');
  const client = useApolloClient();
  const updateTaxDocument = useCallback(
    form =>
      client
        .mutate({
          mutation: Mutations.AdminUpdateTaxDocument, // TODO: change the query with a new query
          variables: { ...form },
          context,
        })
        .then(response => response.data.updateTaxDocument),
    [client, context],
  );
  return updateTaxDocument;
};

export default useUpdateTaxDocument;
